import { colors } from '../../style/style-variables';
import { styled } from 'solid-styled-components';

export const StyledContacts = styled.div`
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StyledAddressContainer = styled.div`
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;

    a {
        color: ${colors.red};
        text-decoration: none;
    }

    @media (min-width: 920px) {
        margin-bottom: 0;
    }
`;

export const StyledContactHeadline = styled.h2`
    font-size: 24px;
    margin: 1rem 0;
    text-align: center;
`;

export const StyledNoContactsContainer = styled.div`
    width: 100%;
    text-align: center;
`;

export const StyledContactItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 1rem;

    img {
        margin-bottom: 1rem;
        border-radius: 5px;
        box-shadow: 0px 2px 8px rgb(0 0 0 / 10%);
    }
`;

export const StyledContactName = styled.div<StyledContactNameProps>`
    font-size: 20px;
    font-weight: 700;
    color: ${colors.black};
    ${(p) => (!p.hasJobTitle ? 'margin-bottom: 0.75rem;' : '')}
    text-align: center;
`;
type StyledContactNameProps = {
    hasJobTitle?: boolean;
};

export const StyledContactTel = styled.div`
    background: ${colors.red};
    color: #fff;
    font-weight: 700;
    border-radius: 8px;
    padding: 0.75rem 1.5rem;
    margin-bottom: 0.5rem;

    a {
        color: #fff;
        margin: 0 0.25rem;
    }
`;

export const StyledContactEmails = styled.div`
    text-align: center;
`;

export const StyledContactEmailLink = styled.a`
    color: ${colors.red};
    font-size: 18px;
    display: block;
    margin: 0.25rem;
`;

export const StyledJobTitle = styled.p`
    font-size: 16px;
    color: ${colors.black};
    text-align: center;
`;

export const StyledContactsList = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    padding-top: 0.5rem;
    gap: 1.5rem;
    margin-bottom: 1.5rem;

    @media (min-width: 920px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: 100%;
        margin-bottom: 3rem;
        padding-top: 1.5rem;
    }
`;

export const StyledSelectWrapper = styled.div`
    width: 100%;
    margin-bottom: 2.5rem;

    @media (min-width: 920px) {
        max-width: 520px;
    }
`;

export const StyledContactAreas = styled.div``;

export const StyledContactArea = styled.div`
    font-size: 16px;
    font-weight: 700;
`;

export const StyledAreaHeader = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    border: transparent;
    border-bottom: ${colors.gray} 1px solid;
    width: 100%;
    padding-bottom: 0.25rem;
    margin-bottom: 1rem;

    @media (min-width: 920px) {
        flex-direction: row;
    }
`;

export const StyledGenericContactWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
`;
